<template>
  <v-dialog
    v-model="dialogValue"
    v-bind="dialogBindings"
    v-on="dialogListeners"
  >
    <template v-if="hasSlot('activator')" v-slot:activator="slotProps">
      <slot name="activator" v-bind="slotProps" />
    </template>
    <v-card>
      <v-card-title
        v-if="isHeaderVisible()"
        class="headline grey lighten-2 layout align-center py-2 st-dialog__title"
      >
        <div class="st-dialog__title-content">
          <slot name="header">{{ label }}</slot>
        </div>
        <v-btn
          v-if="showClose"
          type="button"
          flat
          icon
          class="st-dialog__close"
          aria-label="Close"
          @click="close"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <slot />
      </v-card-text>
      <template v-if="hasSlot('footer')">
        <v-divider />
        <v-card-actions>
          <slot name="footer" />
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.st-dialog__title {
  flex-wrap: nowrap;
}

.st-dialog__title-content {
  flex: 1 1 auto;
  min-width: 0;
}

.st-dialog__close.v-btn {
  flex: 0 0 auto;
  margin: 0 0 0 8px;
}
</style>

<style lang="scss">
.v-dialog.st-dialog {
  display: flex;
  flex-direction: column;
  overflow: visible;

  > .v-card {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  > .v-card > .v-card__title,
  > .v-card > .v-divider,
  > .v-card > .v-card__actions {
    flex: 0 0 auto;
  }

  > .v-card > .v-card__text {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    backface-visibility: hidden;
  }
}

.v-dialog.st-dialog:not(.v-dialog--fullscreen) {
  max-height: none;

  > .v-card {
    max-height: calc(90vh - 48px);
  }
}

.v-dialog.st-dialog.v-dialog--fullscreen {
  overflow: hidden;

  > .v-card {
    height: 100%;
    max-height: 100%;
  }
}
</style>

<script>
import src from './src'
export default src
</script>
